<template>
  <div v-if="taxa" class="card card-body shadow-sm mt-0">
    <div class="form-header d-flex justify-content-between align-items-center">
      <h4 class="form-title">Detalhes da Taxa de Pagamento</h4>
      <router-link to="/financeiro/parametros/taxas">
        <button class="btn btn-secondary btn-sm">Voltar</button>
      </router-link>
    </div>

    <div class="form-content mt-3">
      <FormSection title="">
        <p><strong>Operador:</strong> {{ taxa.nome_operador || 'Não informado' }}</p>
        <p><strong>Bandeira:</strong> {{ taxa.nome_bandeira || 'Não informado' }}</p>
        <p><strong>Tipo:</strong> {{ taxa.nome_tipo || 'Não informado' }}</p>
        <p><strong>Taxa (%):</strong> {{ formatTaxa(taxa.taxa) }}</p>
        <p><strong>Criado em:</strong> {{ formatDate(taxa.criado_em) }}</p>
        <p><strong>Atualizado em:</strong> {{ formatDate(taxa.atualizado_em) }}</p>
      </FormSection>
    </div>
  </div>

  <div v-else>
    <LoadingSpinner />
  </div>
</template>

<script>
import axios from "@/services/axios";
import FormSection from "@/components/Layout/FormSection.vue";

export default {
  components: { FormSection },
  data() {
    return {
      taxa: null,
    };
  },
  methods: {
    async carregarDetalhesTaxa() {
      try {
        const response = await axios.get(
          `/financeiro/parametros/taxas/${this.$route.params.id}`
        );
        this.taxa = response.data;
      } catch (error) {
        console.error("Erro ao carregar os detalhes da taxa:", error);
      }
    },
    formatDate(data) {
      if (!data) return "Não informado";
      return new Date(data).toLocaleString();
    },
    formatTaxa(value) {
      if (value == null || isNaN(value)) return "Não informado";
      return parseFloat(value).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
  mounted() {
    this.carregarDetalhesTaxa();
  },
};
</script>

<style scoped>
.card {
  max-width: 90%;
  margin: 0 auto;
}
.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0rem;
}
.form-header h4 {
  margin: 0;
  font-weight: bold;
  text-align: left;
}
.form-content {
  margin-top: 1.5rem;
}
button.btn-sm {
  padding: 6px 12px;
}
</style>
